var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.DatasetPermissionsForm,{attrs:{"loading":_setup.loading,"simple-permissions":_setup.simplePermissions,"title":_setup.title,"form-config":_setup.formConfig,"checked":_setup.checked},on:{"change":_setup.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }